var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 103,
    viewBox: "0 0 109 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_3650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.738281 19C0.738281 8.50659 9.24487 0 19.7383 0H108.738V103H54.7383C24.9149 103 0.738281 78.8234 0.738281 49V19Z",
    fill: "url(#paint0_linear_3001_3650)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5923 61.576L69.2293 55.213C68.6638 54.646 67.9108 54.334 67.1098 54.334C67.1098 54.334 67.1083 54.334 67.1068 54.334C66.3058 54.334 65.5528 54.6475 64.9873 55.213L60.7453 59.455L48.0178 46.7275L52.2598 42.4855C53.4298 41.3155 53.4298 39.4105 52.2583 38.2405L45.8938 31.8775C45.3283 31.312 44.5753 31 43.7743 31C42.9718 31 42.2173 31.3135 41.6518 31.8805L35.2873 38.245C35.0938 38.437 33.4168 40.252 34.2133 44.2405C35.1523 48.934 39.0823 54.769 45.8938 61.5805C55.6423 71.329 61.7908 73.486 65.3233 73.486C67.7683 73.486 68.9623 72.4525 69.2293 72.1855L75.5923 65.8225C76.1593 65.2555 76.4728 64.501 76.4713 63.6985C76.4713 62.8975 76.1593 62.143 75.5923 61.576ZM67.1083 70.063C67.0663 70.105 61.9948 73.4365 48.0148 59.458C33.7333 45.178 37.4143 40.3645 37.4083 40.366L43.7728 34L50.1373 40.366L44.8348 45.6685C44.2483 46.255 44.2483 47.203 44.8348 47.7895L59.6833 62.638C60.2698 63.2245 61.2178 63.2245 61.8043 62.638L67.1068 57.334L73.4713 63.7L67.1083 70.063Z",
    fill: "#500188"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3001_3650",
    x1: 0.738281,
    y1: 0,
    x2: 103.623,
    y2: 107.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_3650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 103,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3fe6b318b36102185c8b425e249fb612.svg";
export { ForwardRef as ReactComponent };